import {
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    Tooltip
  } from '@mui/material';
  import DeleteIcon from '@mui/icons-material/Delete';
  import { useState } from 'react';
  import axios from 'axios';
  import { toast } from 'react-toastify';
  import { useDispatch } from 'react-redux';
  import { fetchProductListDataStore } from '../../../../Reducer/dataAdminSlice';
  import { LoadingButton } from '@mui/lab';
  
  export default function DeleteButton({ record_id }) {
    const [openConfirm, setOpenConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
  
    const handleDeleteClick = () => {
      setOpenConfirm(true);
    };
  
    const handleClose = () => {
      if (!loading) setOpenConfirm(false);
    };
  
    const confirmDelete = async () => {
      setLoading(true);
      try {
        await axios.delete(`/api/v1/delete-data-store-records/${record_id}`);
        dispatch(fetchProductListDataStore({ page: 1, limit: 10, event_name: '' }));
        toast.success('Deleted successfully');
      } catch (error) {
        console.error('Delete error:', error);
        toast.error('Error deleting record');
      } finally {
        setLoading(false);
        setOpenConfirm(false);
      }
    };
  
    return (
      <>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={handleDeleteClick}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
  
        <Dialog open={openConfirm} onClose={handleClose}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" disabled={loading}>
              Cancel
            </Button>
            <LoadingButton
              onClick={confirmDelete}
              loading={loading}
              color="error"
              variant="contained"
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  